// extracted by mini-css-extract-plugin
export var btn = "styles-module--btn--e1ec7";
export var btnCopied = "styles-module--btnCopied--465a7";
export var btnItem = "styles-module--btnItem--bbf6d";
export var controls = "styles-module--controls--2b5b9";
export var share = "styles-module--share--57ecd";